export default __webpack_public_path__ + "static/media/green1-big.25564ea1.png";